import cn from "clsx";

import type { FeedItem } from "../../../../types/content/feedItem";

import styles from "./TopicArticlesList.module.scss";
import { TeaserCluster } from "../../../TeaserCluster/TeaserCluster";
import { isInjectable } from "../../../../utils/typechecks";
import { FeedItemToTeaser } from "../../utils/feedItemToTeaser";

const TopicArticlesList = ({
  feedItem,
  isFirstElement,
  shouldPrioritizeImageLoad,
  endOfFeed,
  positionInFeed,
}: {
  feedItem: FeedItem;
  isFirstElement?: boolean;
  shouldPrioritizeImageLoad?: boolean;
  endOfFeed?: boolean;
  positionInFeed: number;
}) => {
  if (!feedItem || isInjectable(feedItem)) {
    return null;
  }

  return (
    <div
      className={cn([
        styles.topicArticleContainer,
        isFirstElement && styles.firstArticle,
        endOfFeed && styles.endOfFeed,
      ])}
    >
      <TeaserCluster
        footer={feedItem.footer}
        header={feedItem.header}
        style={feedItem.style}
        hasCardStyling={false}
        isSmallCluster
        teaserWeightValue={feedItem.weight}
      >
        <FeedItemToTeaser
          feedItem={feedItem}
          positionInFeed={positionInFeed}
          shouldPrioritizeImages={shouldPrioritizeImageLoad}
        />
      </TeaserCluster>
      {!endOfFeed && <hr className={styles.separator} />}
    </div>
  );
};

export { TopicArticlesList };
